export default __webpack_public_path__ + "static/media/xiaochengxuma.11876160.png";